'use client'

import { useSyncExternalStore } from 'react'
import { THEME_CHANGE_EVENT } from '@/lib/dither-colors'

export type Theme = 'light' | 'dark'

function subscribe(onChange: () => void) {
  window.addEventListener(THEME_CHANGE_EVENT, onChange)
  return () => window.removeEventListener(THEME_CHANGE_EVENT, onChange)
}

const snapshot = (): Theme =>
  document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light'

/**
 * The site's current theme (html[data-theme]), following THEME_CHANGE_EVENT
 * from the toggle and the system setting. Undefined on the server and during
 * hydration, since the theme is only known in the browser.
 */
export function useTheme(): Theme | undefined {
  return useSyncExternalStore<Theme | undefined>(subscribe, snapshot, () => undefined)
}
